import { render, staticRenderFns } from "./VideoUploadDgBody.vue?vue&type=template&id=18cf51ef&scoped=true"
import script from "./VideoUploadDgBody.vue?vue&type=script&lang=js"
export * from "./VideoUploadDgBody.vue?vue&type=script&lang=js"
import style0 from "./VideoUploadDgBody.vue?vue&type=style&index=0&id=18cf51ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf51ef",
  null
  
)

export default component.exports